import React from 'react';

import * as PanelNames from '../CartoLib/Panels/PanelNames';

import PlanningAlertIcon from '@material-ui/icons/NotificationImportant';
import LandAssemblyIcon from '@material-ui/icons/BorderAll';

import { SearchIcon, GBPIcon } from '../UI/icons';
import FormatPaintIcon from '@material-ui/icons/FormatPaint';
import Layers from './panels/layers/Layers';

import { Map as LayersIcon } from '@material-ui/icons';
import SiteSeeker from './panels/site/SiteSeeker';
import OwnershipSearch from './panels/ownershipsearch/OwnershipSearch';
import Comparable from './panels/comparable/Comparable';
import PlanningPanel from './panels/planning/PlanningPanel';
import PlanningHeader from './panels/planning/PlanningHeader';
import {
    LAND_ASSEMBLY,
    PLANNING_ALERTS,
    SEARCH,
    OWNERSHIP_SEARCH,
    NEW_SKETCHES,
    DRAWN_SKETCHES
} from '../../redux/panel/PanelNames';
import LandAssemblyPanel from './panels/landassembly/LandAssemblyPanel';
import NewSketchesHeader from './panels/drawnsketches/newSketches/NewSketchesHeader';
import NewSketchesBody from './panels/drawnsketches/newSketches/NewSketchesBody';
import DrawnSketchesBody from './panels/drawnsketches/DrawnSketchesBody';

export default {
    [PanelNames.comparable]: {
        title: 'Comparables',
        disabled: false,
        position: 'top',
        icon: <GBPIcon />,
        feature: 'comparable',
        class: Comparable
    },
    [SEARCH]: {
        title: 'SiteFinder',
        disabled: false,
        position: 'top',
        icon: <SearchIcon />,
        feature: 'siteFinder',
        class: SiteSeeker
    },
    [PLANNING_ALERTS]: {
        title: 'Planning Alerts',
        disabled: false,
        position: 'top',
        icon: <PlanningAlertIcon />,
        feature: PLANNING_ALERTS,
        class: PlanningPanel,
        header: PlanningHeader
    },
    [LAND_ASSEMBLY]: {
        title: 'Land Assembly',
        disabled: false,
        position: 'top',
        icon: <LandAssemblyIcon />,
        feature: LAND_ASSEMBLY,
        class: LandAssemblyPanel
    },
    [OWNERSHIP_SEARCH]: {
        title: 'Ownership Search',
        position: 'top',
        icon: <SearchIcon />,
        feature: 'ownershipSearch',
        class: OwnershipSearch
    },
    [PanelNames.dataLayers]: {
        title: 'Control Centre',
        position: 'top',
        icon: <LayersIcon />,
        class: Layers
    },
    [NEW_SKETCHES]: {
        title: 'New Sketches',
        class: NewSketchesBody,
        header: NewSketchesHeader
    },
    [DRAWN_SKETCHES]: {
        title: 'Drawn Sketches',
        icon: <FormatPaintIcon />,
        class: DrawnSketchesBody
    }
};
